import React, { Component } from "react";
import logo from "./../../media/icons/logo_novabank-05.svg";
import MdSearch from "react-icons/lib/md/search";
import { Link } from "react-router-dom";
import setNavigation from "./../../actions/set_navigation";
import get_categories from "./../../actions/get_categories";
import get_page from "./../../actions/get_page";
import MdClose from "react-icons/lib/md/close";
import MdMenu from "react-icons/lib/md/menu";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "Bireysel",
      lang: "TR",
      show_menu: false,
      categories: []
    };
  }
  changeLang = lang => {
    this.setState({
      lang: this.state.lang === "TR" ? "EN" : "TR"
    });
  };
  async componentDidMount() {
    await this.props.get_categories();
    await this.props.get_page();
    let categories = this.props.categories
      .sort((v1, v2) => v2.index - v1.index)
      .map(v => v);
    categories = categories.map(i => {
      i.sub_categories = i.sub_categories
        .sort((v1, v2) => v1.index - v2.index)
        .map(v => v);
      return i;
    });
    this.setState({
      categories,
      q: this.props.location.search.split("?q=").join("")
    });
    let bannerHeight = document.getElementsByClassName("banner_holder")[0]
      ? document.getElementsByClassName("banner_holder")[0].clientHeight
      : 80;
    this.setState({
      bannerHeight
    });
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll = () => {
    let lastScrollY = window.scrollY;
    if (this.state.bannerHeight < lastScrollY) {
      this.setState({
        fixed: true
      });
    } else {
      this.setState({
        fixed: false
      });
    }
  };

  render = () => (
    <div className={`menu ${this.state.fixed ? "fixed" : ""}`}>
      <div className="container row">
        <div className={`${this.props.screen.mq === "l" ? "col-2" : "col-3"} `}>
          <Link
            className={`${this.props.screen.mq === "l" ? "" : "m"} logo `}
            to={"/"}
          >
            <img alt="" src={logo} />
          </Link>
        </div>
        <div
          className={`${this.props.screen.mq === "l" ? "col-10" : "col-9"} `}
        >
          {this.props.screen.mq === "l" || this.props.screen.mq === "m" ? (
            <div
              className={`${this.props.screen.mq === "m" ? "m" : ""} search`}
            >
              <div className="lang">
                <a
                  onClick={this.changeLang}
                  className={this.state.lang === "TR" ? "active" : ""}
                >
                  TR
                </a>
                /
                <a
                  onClick={this.changeLang}
                  className={this.state.lang === "EN" ? "active" : ""}
                >
                  EN
                </a>
              </div>
              <div className="search_wrapper">
                <input
                  value={this.state.q}
                  onChange={e => {
                    this.setState({
                      q: e.target.value
                    });
                  }}
                  placeholder="Ne Aramıştınız?"
                />
                <button
                  onClick={() => {
                    this.props.history.push(`/ara?q=${this.state.q}`);
                  }}
                  className="trigger-search"
                >
                  <MdSearch />
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
          {
            <nav>
              {this.props.screen.mq === "l" || this.props.screen.mq === "m" ? (
                ""
              ) : (
                <button
                  onClick={() => {
                    this.setState({
                      show_menu: true
                    });
                  }}
                  className="close_menu"
                >
                  <MdMenu />
                </button>
              )}
              {this.props.screen.mq === "l" ||
              this.props.screen.mq === "m" ||
              this.state.show_menu ? (
                this.props.screen.mq === "l" || this.props.screen.mq === "m" ? (
                  <div
                    className={`${
                      this.props.screen.mq === "l" ||
                      this.props.screen.mq === "m"
                        ? ""
                        : "s"
                    } `}
                  >
                    <Link
                      onClick={() => {
                        this.setState({ show_menu: false });
                        this.props.setNavigation(["contact-us"]);
                      }}
                      to={"/contact-us"}
                      className={
                        this.props.navigation[0] === "contact-us menu_item"
                          ? "active menu_item"
                          : "menu_item"
                      }
                    >
                      İLETİŞİM
                    </Link>
                    <Link
                      onClick={() => {
                        this.setState({ show_menu: false });
                        this.props.setNavigation(["hakkimızda"]);
                      }}
                      to={"/hakkimızda"}
                      className={
                        this.props.navigation[0] === "hakkimızda"
                          ? "active menu_item"
                          : "menu_item"
                      }
                    >
                      HAKKIMIZDA{" "}
                    </Link>
                    <Link
                      onClick={() => {
                        this.setState({ show_menu: false });
                        this.props.setNavigation(["bultens"]);
                      }}
                      to={"/bultens"}
                      className={
                        this.props.navigation[0] === "bultens"
                          ? "active menu_item"
                          : "menu_item"
                      }
                    >
                      BÜLTENLER{" "}
                    </Link>
                    {this.props.pages.map((item, key) => (
                      <Link
                        key={key}
                        onClick={() => {
                          this.setState({ show_menu: false });
                          this.props.setNavigation([item.url]);
                        }}
                        to={`/pages/${item.url}`}
                        className={
                          this.props.navigation[0] === item.url
                            ? "active menu_item"
                            : "menu_item"
                        }
                      >
                        {item.title}
                      </Link>
                    ))}
                    {this.state.categories.map((item, key) => (
                      <Link
                        key={key}
                        onClick={() => {
                          this.setState({ show_menu: false });
                          this.props.setNavigation([item.url]);
                        }}
                        to={`/${item.url}`}
                        className={
                          this.props.navigation[0] === item.url
                            ? "active menu_item"
                            : "menu_item"
                        }
                      >
                        {item.title}
                        {item.sub_categories.length > 0 ? (
                          <div className="sub_menu">
                            <div className="sub_menu_wrapper">
                              {item.sub_categories.map((subItem, key) => (
                                <Link
                                  key={key}
                                  onClick={() => {
                                    this.setState({ show_menu: false });
                                    this.props.setNavigation([subItem.url]);
                                  }}
                                  to={`/${item.url}/${subItem.url}`}
                                  className={
                                    this.props.navigation[0] === subItem.url
                                      ? "active sub_menu_item"
                                      : "sub_menu_item"
                                  }
                                >
                                  {subItem.title}{" "}
                                </Link>
                              ))}
                            </div>
                          </div>
                        ) : null}
                      </Link>
                    ))}
                    <Link
                      onClick={() => {
                        this.setState({ show_menu: false });
                        this.props.setNavigation([]);
                      }}
                      to={"/"}
                      className={
                        this.props.navigation.length === 0
                          ? "active menu_item"
                          : "menu_item"
                      }
                    >
                      ANASAYFA
                    </Link>
                  </div>
                ) : (
                  <div
                    className={`${
                      this.props.screen.mq === "l" ||
                      this.props.screen.mq === "m"
                        ? ""
                        : "s"
                    } `}
                  >
                    {this.props.screen.mq === "l" ||
                    this.props.screen.mq === "m" ? (
                      ""
                    ) : (
                      <button
                        onClick={() => {
                          this.setState({
                            show_menu: false
                          });
                        }}
                        className="close_menu"
                      >
                        <MdClose />
                      </button>
                    )}
                    <Link
                      onClick={() => {
                        this.setState({ show_menu: false });
                        this.props.setNavigation([]);
                      }}
                      to={"/"}
                      className={
                        this.props.navigation.length === 0
                          ? "active menu_item"
                          : "menu_item"
                      }
                    >
                      ANASAYFA
                    </Link>

                    {this.state.categories.map((item, key) => (
                      <Link
                        key={key}
                        onClick={() => {
                          this.setState({ show_menu: false });
                          this.props.setNavigation([item.url]);
                        }}
                        to={`/${item.url}`}
                        className={
                          this.props.navigation[0] === item.url
                            ? "active menu_item"
                            : "menu_item"
                        }
                      >
                        {item.title}
                        {item.sub_categories.length > 0 ? (
                          <div className="sub_menu">
                            <div className="sub_menu_wrapper">
                              {item.sub_categories.map((subItem, key) => (
                                <Link
                                  key={key}
                                  onClick={() => {
                                    this.setState({ show_menu: false });
                                    this.props.setNavigation([subItem.url]);
                                  }}
                                  to={`/${item.url}/${subItem.url}`}
                                  className={
                                    this.props.navigation[0] === subItem.url
                                      ? "active sub_menu_item"
                                      : "sub_menu_item"
                                  }
                                >
                                  {subItem.title}{" "}
                                </Link>
                              ))}
                            </div>
                          </div>
                        ) : null}
                      </Link>
                    ))}
                    {this.props.pages.map((item, key) => (
                      <Link
                        key={key}
                        onClick={() => {
                          this.setState({ show_menu: false });
                          this.props.setNavigation([item.url]);
                        }}
                        to={`/pages/${item.url}`}
                        className={
                          this.props.navigation[0] === item.url
                            ? "active menu_item"
                            : "menu_item"
                        }
                      >
                        {item.title}
                      </Link>
                    ))}
                    <Link
                      onClick={() => {
                        this.setState({ show_menu: false });
                        this.props.setNavigation(["bultens"]);
                      }}
                      to={"/bultens"}
                      className={
                        this.props.navigation[0] === "bultens"
                          ? "active menu_item"
                          : "menu_item"
                      }
                    >
                      BÜLTENLER{" "}
                    </Link>
                    <Link
                      onClick={() => {
                        this.setState({ show_menu: false });
                        this.props.setNavigation(["hakkimızda"]);
                      }}
                      to={"/hakkimızda"}
                      className={
                        this.props.navigation[0] === "hakkimızda"
                          ? "active menu_item"
                          : "menu_item"
                      }
                    >
                      HAKKIMIZDA{" "}
                    </Link>
                    <Link
                      onClick={() => {
                        this.setState({ show_menu: false });
                        this.props.setNavigation(["contact-us"]);
                      }}
                      to={"/contact-us"}
                      className={
                        this.props.navigation[0] === "contact-us menu_item"
                          ? "active menu_item"
                          : "menu_item"
                      }
                    >
                      İLETİŞİM
                    </Link>
                  </div>
                )
              ) : (
                ""
              )}
            </nav>
          }
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  navigation: state.navigation,
  screen: state.screen,
  pages: state.pages,
  categories: state.categories ? state.categories.data : []
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNavigation,
      get_categories,
      get_page
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Menu));
